import { times } from 'lodash'

export const priceDecimals = times(101, (index) => {
    return index < 10 ? `0${index}` : `${index}`
})
